import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initSentry, Sentry } from "./lib/sentry";

// Инициализируем Sentry первым — чтобы поймать ошибки самого React-рендера.
initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Произошла ошибка. Сообщим админам.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
